import request from '@/apis/request'
const resource = 'number-templates'
const resource2 = 'number-types'

export default {
  getNumberType: () => {
    return request.get(`${resource2}/`)
  },

  get: (params = {}) => {
    return request.get(`${resource}`,{ params })
  },

  getById: (uid) => { 
    return request.get(`${resource}/${uid}`)
  },

  create: (data) => { 
    return request.post(`${resource}`,data)
  },

  update: (uid,data) => { 
    return request.put(`${resource}/${uid}`,data)
  },

  delete: (uid) => { 
    return request.delete(`${resource}/${uid}`)
  },
}